import { useEffect, useState } from 'react';

import { countChars } from 'src/lib/string';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { useProjectActions } from 'src/store';
import { SUGGESTED_TITLE_LENGTH_LIMIT } from 'src/store/project/ProjectStore';

import { LocalStore } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, [
  'briefContent',
  'freestyleToolContent',
  'rewriteText',
]);

const sliceTitle = (title) => {
  if (title.length > SUGGESTED_TITLE_LENGTH_LIMIT) {
    return title.slice(0, SUGGESTED_TITLE_LENGTH_LIMIT - 3) + '...';
  }

  return title;
};

export const useSetSuggestedDocumentTitle = () => {
  const projectActions = useProjectActions();
  const { briefContent, freestyleToolContent, rewriteText } = useLocalState();

  const [suggestedTitle, setSuggestedTitle] = useState('');

  useEffect(() => {
    setSuggestedTitle(
      briefContent?.title || briefContent?.body || briefContent?.freeText || briefContent?.article
    );
  }, [briefContent]);

  useEffect(() => {
    setSuggestedTitle(freestyleToolContent.allInstructions);
  }, [freestyleToolContent]);

  useEffect(() => {
    setSuggestedTitle(rewriteText);
  }, [rewriteText]);

  useEffect(() => {
    const isTitleTooLong = countChars(suggestedTitle) > SUGGESTED_TITLE_LENGTH_LIMIT;
    const fixedTitle = isTitleTooLong ? sliceTitle(suggestedTitle) : suggestedTitle;

    projectActions.setProjectSuggestedTitle(fixedTitle);
  }, [projectActions, suggestedTitle]);
};
